// const baseUrl = "http://35.154.4.154/urxpert_gowtham/";
const baseUrl = process.env.REACT_APP_STYLE_BASEURL;

const removeStyleByUrl = (filePath) => {
    const fullUrl = baseUrl + filePath;
    const links = document.querySelectorAll(`link[href="${fullUrl}"]`);
    links.forEach((link) => link.parentNode.removeChild(link));
    console.log("Removed CSS:", fullUrl);
};

const ManagePageStyles = () => {
    const currentPath = window.location.pathname;

    const pathsToRemoveFindWork = [
        "/account/updateproject/",
        "/account/updatecontest/",
        "/account/updatejob/",
    ];

    if (pathsToRemoveFindWork.some((p) => currentPath.includes(p))) {
        removeStyleByUrl("Assets/scss/FindWork.module.scss");
    }

    const chatSearchFindWork = [
        "searchpackaged",
        "searchrentproducts",
        "searchbuyproducts",
        "searchauction",
        "searchmergersacquisitions",
        "searchall",
        "searchdownloadcv",
        "hireexpertsbycategory",
    ];

    if (chatSearchFindWork.some((p) => currentPath.includes(p))) {
        removeStyleByUrl("Assets/scss/chat.module.scss");
    }

};

export default ManagePageStyles;
